import React from "react";

const PILLARS = [
  {
    label: "WORK",
    color: "#017bef",
    title: "Coworking / Meeting",
    description: "Find a workspace near wherever you're staying.",
  },
  {
    label: "STAY",
    color: "#0062c0",
    title: "Hotel / Apartment",
    description: "Discover and book accommodation that fits your trip.",
  },
  {
    label: "PLAY",
    color: "#0ea5e9",
    title: "Dining / Wellness / Adventure",
    description: "Make the most of your time away from the desk.",
  },
];

export default function StayConnected() {
  return (
    <section className="bg-white py-20">
      <div className="mx-auto flex max-w-[1440px] flex-col items-center px-[16px] text-center sm:px-8">
        <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">The Platform</p>
        <h2 className="pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
          Your Stay Doesn't Exist in Isolation
        </h2>
        <p className="max-w-[576px] pt-[16px] text-[18px] leading-7 text-[#717182]">
          SPACIA lets you combine every part of your journey in one place.
        </p>

        <div className="grid w-full max-w-[768px] grid-cols-1 gap-10 pt-14 sm:grid-cols-3 sm:gap-0">
          {PILLARS.map((pillar, index) => (
            <div key={pillar.label} className="relative flex flex-col items-center">
              {/* Dashed link to the next circle (desktop only) */}
              {index < PILLARS.length - 1 && (
                <div className="absolute left-[calc(50%+40px)] top-8 hidden w-[calc(100%-80px)] border-t-2 border-dashed border-[#e5e7eb] sm:block" />
              )}
              <div
                className="mb-[20px] flex size-16 items-center justify-center rounded-full text-[12px] font-bold leading-4 tracking-[1.2px] text-white drop-shadow-[0_4px_10px_rgba(0,0,0,0.1)]"
                style={{ backgroundColor: pillar.color }}
              >
                {pillar.label}
              </div>
              <p className="pb-1 text-[16px] font-bold leading-6 text-[#0a0a0a]">{pillar.title}</p>
              <p className="max-w-[224px] px-[16px] text-[14px] leading-[22.75px] text-[#717182]">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>

        <span className="mt-12 rounded-full bg-[#0a0a0a] px-8 py-[12px] text-[14px] font-bold leading-5 text-white">
          One Platform for Work, Stay and Play
        </span>
      </div>
    </section>
  );
}
